/**
 * `/performance/profiles` — renamed to `/performance/segments`.
 *
 * "Segment" is the standard analytics word for a filtered slice of
 * traffic, and "profile" already meant the account one at
 * `/settings/profile`. The old path stays as a redirect: it shipped in
 * the nav and will be sitting in bookmarks and shared links. The table
 * and API path are still `traffic_profiles` — internal names, unchanged.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/performance/profiles')({
  beforeLoad: () => {
    throw redirect({ to: '/performance/segments' });
  },
});
